import { render, staticRenderFns } from "./DemoBoardView.vue?vue&type=template&id=96863efc&"
import script from "./DemoBoardView.vue?vue&type=script&lang=js&"
export * from "./DemoBoardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports